interface SubCategoryCardProps {
    subCategory: any;
    parentCategoryName?: string;
    onClick: (sub: any) => void;
    onViewProducts?: (sub: any) => void;
}

const SubCategoryCard = ({
    subCategory,
    parentCategoryName,
    onClick,
    onViewProducts,
}: SubCategoryCardProps) => {
    return (
        <div
            className="border m-3 p-4 rounded-lg w-56 cursor-pointer hover:shadow-lg transition-shadow text-left"
            onClick={() => onClick(subCategory)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter") onClick(subCategory); }}
        >
            <div className="flex items-center justify-between mb-2">
                <p className="text-sm font-semibold text-secondary truncate max-w-[140px]">
                    {subCategory.name}
                </p>
                <span
                    className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${subCategory.isActive
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-600"
                        }`}
                >
                    {subCategory.isActive ? "Active" : "Inactive"}
                </span>
            </div>
            {parentCategoryName && (
                <p className="text-xs text-gray-500 truncate">
                    Category: <span className="font-medium">{parentCategoryName}</span>
                </p>
            )}
            <p className="text-[10px] text-gray-400 mt-2">
                {new Date(subCategory.createdAt).toLocaleDateString()}
            </p>

            {onViewProducts && (
                <button
                    type="button"
                    className="mt-3 w-full inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium text-secondary bg-secondary bg-opacity-5 hover:bg-opacity-15 border border-secondary border-opacity-20 transition-colors"
                    onClick={(e) => {
                        e.stopPropagation();
                        onViewProducts(subCategory);
                    }}
                >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                    View Products
                </button>
            )}
        </div>
    );
};

export default SubCategoryCard;
